import { render } from "./HelpTip.vue?vue&type=template&id=73133df4&scoped=true"
import script from "./HelpTip.vue?vue&type=script&lang=js"
export * from "./HelpTip.vue?vue&type=script&lang=js"

import "./HelpTip.vue?vue&type=style&index=0&id=73133df4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73133df4"]])

export default __exports__